<script>
import CoreComponent from "../../../../../../../dow-platform/ui.frontend/src/dow-platform/components/core/CoreComponent.vue";

export default {
  extends: CoreComponent,
  data() {
    return {
      mobileBreakpoint: 1024,
      stickyHeader: false,
      resizeTimeout: null,
      resizeObserver: null,
      diagnosticMode: false, // mark 'true' to force-test .cmp-globalHeader - should be 'false' for regular usage
      headerEl: null
    };
  },
  mounted() {
    this.headerEl = this.cmpEl.classList?.contains('cmp-globalHeader')
      ? this.cmpEl
      : this.cmpEl.querySelector('.cmp-globalHeader');
   
    if (!this.headerEl) {
      console.error('[GlobalHeader] Could not find .cmp-globalHeader element');
      return;
    }

    if (this.diagnosticMode) {
      const elementType = this.cmpEl.classList?.contains('cmp-globalHeader')
        ? 'this.cmpEl (direct match)'
        : 'querySelector result';
      console.warn(`[GlobalHeader Diagnostic] Found element via: ${elementType}`, this.headerEl);
     
      if (!this.headerEl.classList.contains('cmp-globalHeader--fixed')) {
        this.headerEl.classList.add('cmp-globalHeader--fixed');
        console.warn('[GlobalHeader Diagnostic] Added cmp-globalHeader--fixed class for testing');
      }
    }

    this.stickyHeader = this.headerEl.classList.contains('cmp-globalHeader--fixed') || this.diagnosticMode;
   
    if (this.stickyHeader) {
      this.handleStickyHeader();
      window.addEventListener('resize', this.handleResize);
      this.observeHeaderHeight();
    } else {
      this.cleanupStickyHeader();
    }

    const searchComponent = this.headerEl.querySelector(
      ".cmp-globalHeader_search-container"
    );
    const searchElement = this.headerEl.querySelector(".cmp-global-header_links__search");
   
    if (searchElement) {
      searchElement.addEventListener("click", () => {
        if (searchComponent.classList.contains("hide-search")) {
          searchComponent.classList.remove("hide-search");
        } else {
          searchComponent.classList.add("hide-search");
        }
      });
    }
  },
  methods: {
    handleStickyHeader() {

      this.initStickyStyles();

      setTimeout(() => {
        this.initStickyStyles();
      }, 100);
    },
    initStickyStyles() {
      const height = this.headerEl.offsetHeight;
      const breakpoint = window.innerWidth >= this.mobileBreakpoint ? 'desktop' : 'mobile';
     
      document.body.style.marginTop = `${height}px`;
      document.documentElement.style.scrollPaddingTop = `${height + 20}px`;     
     
      if (this.diagnosticMode) {
        console.log(`[GlobalHeader Diagnostic] Height: ${height}px, Breakpoint: ${breakpoint}, Body margin-top: ${document.body.style.marginTop}`);
      }
    },
    observeHeaderHeight() {
      this.resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          this.initStickyStyles();
        }
      });

      this.resizeObserver.observe(this.headerEl);
    },
    handleResize() {
      if (!this.stickyHeader) return;
     
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        this.initStickyStyles();
      }, 250);
    },
    cleanupStickyHeader() {
      document.body.style.marginTop = '';
    }
  },
  beforeUnmount() {
    if (this.stickyHeader) {
      window.removeEventListener('resize', this.handleResize);
    }
   
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
   
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
  }
};

</script>
<style lang="scss">
@import "./GlobalHeader.scss";
</style>